{
  "longPressMessage": "Dugo pritisnite da biste otvorili pregled"
}
